<div layout-full-width layout-horizontal layout-align-items-center layout-space-between>
  <div layout-centered-y>
    <ng-content />
  </div>
  <div layout-centered-y>
    <ng-content select="[slot-right]" />
  </div>
</div>
